/* RebootDeviceAction.js */

"use strict";
const RebootDeviceComponent = require("./RebootDeviceComponent");
const DEVICE_NAME_MAX_LENGTH = 60;
const DEVICE_NAME_LIST_LENGTH = 10;

class RebootDeviceAction {
    constructor(logger, gameEditor, modalUserFeedback, DeviceEntity, OsUpgradePlan, userSession, activityMonitor, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._userSession = userSession;
        this._deviceEntity = DeviceEntity;
        this._osPlan = OsUpgradePlan;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._activityMonitor = activityMonitor;
        this.run = this.run.bind(this);
        this._selectedDeviceIds = [];
        this._selectedDeviceNames = [];

        if (this._activeView && this._activeView.pagingFeed) {
            this._selectedDeviceIds = this._activeView.getSelectedDeviceIds().selectedRows || [];
        }
        this.run = this.run.bind(this);
    }

    run() {
        let rebootDeviceComponent = new RebootDeviceComponent(
            this._logger,
            this._gameEditor,
            this._osPlan,
            this._deviceEntity,
            this._activeView,
            this._modalUserFeedback,
            this._userSession
        );
        if (this._selectedDeviceIds.length) {
            this._activeView.pagingFeed
                .waitForRangeIdsUpdated()
                .then(() => {
                    if (this._selectedDeviceIds.length <= DEVICE_NAME_LIST_LENGTH) {
                        return (this._selectedDeviceNames = this._activeView.pagingFeed.getDeviceEntitiesNameById(this._selectedDeviceIds));
                    }
                    return Promise.resolve();
                })
                .then((selectedDeviceNames) => {
                    this._selectedDeviceNames = selectedDeviceNames || [];
                    if (this._selectedDeviceIds.length <= DEVICE_NAME_LIST_LENGTH) {
                        if (Array.isArray(this._selectedDeviceNames) && this._selectedDeviceNames.length > 0) {
                            let s = this._selectedDeviceNames.length > 1 ? "s" : "";
                            this._message = "Are you sure you want to reboot the selected device" + s + "?\n";
                            Object.keys(this._selectedDeviceNames).forEach((id) => {
                                let deviceName = this._selectedDeviceNames[id];
                                let shortDeviceName =
                                    deviceName.length > DEVICE_NAME_MAX_LENGTH ? deviceName.substr(0, DEVICE_NAME_MAX_LENGTH) + "…" : deviceName;
                                this._message += "\n" + shortDeviceName;
                            });
                            return Promise.resolve();
                        } else {
                            return Promise.reject(new Error("Cannot retrieve the selected devices"));
                        }
                    } else {
                        this._message = `Are you sure you want to reboot the selected ${this._selectedDeviceIds.length} devices?\n`;
                        return Promise.resolve();
                    }
                })
                .then(() => {
                    return this._gameEditor.runQuickConfirmationActionWorkflow(
                        {
                            message: this._message,
                            title: "Reboot devices",
                            confirmDetails: {
                                text: "Confirm",
                                type: "additive"
                            },
                            rejectDetails: {
                                text: "Cancel",
                                type: "text"
                            }
                        },
                        () => {
                            return this._modalUserFeedback.displayCustom(rebootDeviceComponent, { dontHide: true }).catch((err) => {
                                if (err && err.userRejected) {
                                    this._logger.warn({ error: err }, "RebootDeviceAction.run() - User Canceled");
                                    return;
                                } else {
                                    this._logger.warn({ error: err }, "RebootDeviceAction.run() - Error");
                                    return this._modalUserFeedback.displayError(err).catch(() => {
                                        return Promise.resolve();
                                    });
                                }
                            });
                        }
                    );
                })
                .catch((err) => {
                    this._logger.warn({ error: err }, "RebootAction.run() - Error");
                    return this._modalUserFeedback.displayError({ error: { errorMsg: err } });
                });
        } else {
            return Promise.resolve();
        }
    }
}

module.exports = RebootDeviceAction;

RebootDeviceAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.Device",
    "$teve.entities.OsUpgradePlan",
    "$teve.userSession",
    "$teve.activityMonitor",
    "gameEditor.activeView"
];

RebootDeviceAction.$displayDetails = {
    type: "Action",
    name: "RebootDeviceAction",
    icon: "osmanager.reboot",
    shown: true,
    title: "Reboot devices",
    order: 11
};
